export default class DetectedDeviceUtils {
  public static detectPhone(width?: number): string {
    const uagent = navigator.userAgent.toLowerCase();
    let device = 'desktop';

    if (uagent.search('iphone') > -1) {
      device = DETECTED_DEVICE.Mobile;
    } else if (uagent.search('ipad') > -1) {
      device = DETECTED_DEVICE.Mobile;
    } else if (uagent.search('android') === -1 && width < 420) {
      device = DETECTED_DEVICE.Mobile; //only for viewing the mobile screen from the desktop screen
    } else if (uagent.search('android') > -1 && width < 420) {
      device = DETECTED_DEVICE.Mobile;
    } else {
      device = DETECTED_DEVICE.Desktop;
    }
    return device;
  }
}

export enum DETECTED_DEVICE {
  Desktop = 'desktop',
  Mobile = 'mobile',
}
